import React, { ReactNode } from 'react';
import Button from '@atlaskit/button';
import { css } from '@emotion/core';
import { token } from '@atlaskit/tokens';
import { colors } from '@atlaskit/theme';

import { borderRadius } from '@/styles';

const rootStyles = css`
  background-color: transparent !important;
  margin: 0 2px;
`;

const childStyles = css`
  display: flex;
  padding: 0px 6px 1px;
  margin: 4px;
  background-color: ${token('elevation.surface.sunken', colors.N30)};
  color: ${token('color.text.subtle', colors.N600)};
  ${borderRadius}
  cursor: pointer;
`;

type KeyPressPromptButton = {
  children: ReactNode;
  type?: React.ButtonHTMLAttributes<HTMLButtonElement>['type'];
  onClick?: (e: React.MouseEvent<HTMLElement, MouseEvent>) => void;
};

const KeyPressPromptButton: React.FC<KeyPressPromptButton> = ({ children, type, onClick }) => (
  <Button type={type} appearance="subtle" spacing="none" onClick={onClick} css={rootStyles}>
    <span css={childStyles}>{children}</span>
  </Button>
);

export default KeyPressPromptButton;
